import { Button, ErrorPage } from 'armxlib'
import { en } from '../i18n/en'
import { ROUTES } from '../routes'
import { PageMeta } from './PageMeta'

/** Any unknown URL. nginx answers it with a real 404 status. */
export function NotFoundPage() {
  return (
    <>
      <PageMeta title={en.notFound.title} />
      <ErrorPage
        ascii
        code="404"
        title={en.notFound.title}
        description={en.notFound.description}
        action={
          <Button variant="primary" href={ROUTES.chat.path}>
            {en.nav.backToChat}
          </Button>
        }
      />
    </>
  )
}
